import {
  FETCH_PROVVIGIONI_START,
  FETCH_PROVVIGIONI_SUCCESS,
  FETCH_PROVVIGIONI_FAILURE,
  FETCH_PROVVIGIONE_START,
  FETCH_PROVVIGIONE_SUCCESS,
  FETCH_PROVVIGIONE_FAILURE,
  SAVE_PROVVIGIONE_START,
  SAVE_PROVVIGIONE_SUCCESS,
  SAVE_PROVVIGIONE_FAILURE,
  VERSIONA_PROVVIGIONE_START,
  VERSIONA_PROVVIGIONE_SUCCESS,
  VERSIONA_PROVVIGIONE_FAILURE,
  DELETE_PROVVIGIONE_START,
  DELETE_PROVVIGIONE_SUCCESS,
  DELETE_PROVVIGIONE_FAILURE,
  ARCHIVIA_PROVVIGIONE_START,
  ARCHIVIA_PROVVIGIONE_SUCCESS,
  ARCHIVIA_PROVVIGIONE_FAILURE,
} from '../actions/Provvigioni';

const initialState = {
  provvigioni: [],
  currentProvvigione: null,
  loading: false,
  error: null,
};

export default function provvigioniReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PROVVIGIONI_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_PROVVIGIONI_SUCCESS:
      return {
        ...state,
        loading: false,
        provvigioni: action.payload,
        error: null,
      };

    case FETCH_PROVVIGIONI_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_PROVVIGIONE_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_PROVVIGIONE_SUCCESS:
      return {
        ...state,
        loading: false,
        currentProvvigione: action.payload,
        error: null,
      };

    case FETCH_PROVVIGIONE_FAILURE:
      return {
        ...state,
        loading: false,
        currentProvvigione: null,
        error: action.payload,
      };

    case SAVE_PROVVIGIONE_START:
    case VERSIONA_PROVVIGIONE_START:
    case DELETE_PROVVIGIONE_START:
    case ARCHIVIA_PROVVIGIONE_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case SAVE_PROVVIGIONE_SUCCESS:
    case VERSIONA_PROVVIGIONE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case SAVE_PROVVIGIONE_FAILURE:
    case VERSIONA_PROVVIGIONE_FAILURE:
    case DELETE_PROVVIGIONE_FAILURE:
    case ARCHIVIA_PROVVIGIONE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PROVVIGIONE_SUCCESS:
      return {
        ...state,
        loading: false,
        provvigioni: state.provvigioni.filter(p => p.id !== action.payload),
        error: null,
      };

    case ARCHIVIA_PROVVIGIONE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    default:
      return state;
  }
}
